import React, { useState, useCallback } from 'react';
import { 
    Avatar, 
    Box, 
    Tooltip} from "@mui/material";
import {useTheme} from '@mui/material/styles';
import { ProjectInfoDialog } from './Dialogs/projectInfoDialog';
import { Chip } from '@mui/material/node';

const ProfilMenuInfo = ({ userData = {}, projectData }) => {
    const { name = 'User', picurl } = userData;
    const [anchorElUser, setAnchorElUser] = useState(null);
    const [showProjectInfoDialog, setShowProjectInfoDialog] = useState(false);
    const theme = useTheme();

    const handleOpenUserMenu = useCallback((event) => {
        setShowProjectInfoDialog(true);
    }, []);

    const handleCloseProjectInfoDialog = useCallback(() => {
        setShowProjectInfoDialog(false);
    }, []);

    return (
        <>
            <Box sx={{ position: 'fixed', top: { xs: 62, sm: 72 }, right: 10, zIndex: 0 }}>
                <Tooltip title={`${name || 'User'}`}>
                <Chip
  avatar={<Avatar alt="Natacha" src={picurl || ''} />}
  label={projectData?.name 
    ? (projectData.name.length > 15 ? projectData.name.slice(0, 12) + '...' : projectData.name) 
    : 'Project'}
  variant="outlined"
  onClick={handleOpenUserMenu}
/>
                    {/* <IconButton 
                        onClick={handleOpenUserMenu} 
                        sx={{ 
                            p: 0, 
                            color: theme.palette.menuIcon.secondary,
                            '&:hover': {
                                backgroundColor: theme.palette.profileMenu.hover
                            }
                        }}
                        aria-label="User menu"
                        aria-controls={anchorElUser ? 'menu-appbar' : undefined}
                        aria-haspopup="true"
                    >
                        <Avatar 
                            alt={name || 'User'} 
                            src={picurl || ''} 
                            sx={{ 
                                width: 40, 
                                height: 40,
                                border: `2px solid ${theme.palette.profileMenu.avatar.border}`,
                                '&:hover': {
                                    border: `2px solid ${theme.palette.primary.main}`
                                }
                            }} 
                        />
                    </IconButton> */}
                </Tooltip>
            </Box>
            <ProjectInfoDialog
                open={showProjectInfoDialog}
                handleClose={handleCloseProjectInfoDialog}
                ownerData={userData}
                projectData={projectData}
            />
        </>
    );
};

export { ProfilMenuInfo };